import React from 'react';

function FlagIconUa({ w, h, style, className }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}px`}
      height={`${h}px`}
      viewBox="0 0 512 512"
      className={className}
      style={style}
    >
      <circle fill="#FFDA44" cx="256" cy="256" r="256" />
      <path fill="#338AF3" d="M0,256C0,114.616,114.616,0,256,0s256,114.616,256,256" />
    </svg>
  );
}

FlagIconUa.defaultProps = {
  w: 20,
  h: 20,
  style: {},
  fill: '#000',
};

export default FlagIconUa;
